var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy_area"},_vm._l((_vm.cdkInfo.cdk),function(item,i){return _c('div',{key:i,staticClass:"copy_item"},[_c('span',{staticClass:"copy_text"},[_vm._v(_vm._s(item))]),_c('span',{staticClass:"copy_btn",on:{"click":function($event){return _vm.copy(item)}}},[_vm._v("复制")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }